export * from './customerlist.component';